class AddSubcontractorToContractModalController {
  constructor($scope, $uibModalInstance, $uibModal, $rootScope, AuthenticationService, $timeout, $http) {
      "ngInject";
      this.name = 'addSubcontractorToContractModal';

      let self = this;
      this.http = $http;

      $scope.subcontractor;

      $http.get($rootScope.apiHost+'/api/admin/subcontractors', {withCredentials: true}).then(function (success) {
        $scope.subcontractors = success.data;
      });


      $scope.done = function() {
          $uibModalInstance.dismiss('cancel');
      }

      $scope.cancel = function () {
          $uibModalInstance.dismiss('cancel');
      };

    $scope.addSubcontractor = function () {
      $uibModalInstance.success($scope.subcontractor);
    }


  }
}

export default AddSubcontractorToContractModalController;



// WEBPACK FOOTER //
// ./client/common/modals/addSubcontractorToContractModal/addSubcontractorToContractModal.controller.js